import { Component, forwardRef, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { AssetDao } from '@app/dao/asset/asset.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import * as _ from 'lodash';
import { BehaviorSubject, combineLatest, Subject, switchMap } from 'rxjs';
import { PrPmeFormBuilder } from './ea-pme-form.builder';
import { EaAutresFormComponent } from '@app/forms/assets/ea-autres-form/ea-autres-form.component';

@Component({
    selector: 'ea-pme-form',
    templateUrl: './ea-pme-form.component.html',
    styleUrls: ['./ea-pme-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaPmeFormComponent),
        },
    ],
    standalone: false
})
export class EaPmeFormComponent extends PrPmeFormBuilder implements OnInit {
  users: any[];
  references: any;
  groupes: any[];
  sources: any[];
  managers: any[];
  _ = _;
  doneSubject: Subject<void> = new Subject<void>();
  tabChanged: BehaviorSubject<any> = new BehaviorSubject(null);
  changeTab: BehaviorSubject<any> = new BehaviorSubject(null);

  // Étape de choix affichée à l'ajout : Private Equity "classique" (PME) +
  // les fonds de la famille private equity (FPCI / FPCR / FCPR / FPS).
  // Doit rester aligné sur AssetTypeService.getPrivateEquityOptions().
  products = [
    { id: 'PME', label: 'Private Equity' },
    { id: 'FPCI', label: 'FPCI' },
    { id: 'FPCR', label: 'FPCR' },
    { id: 'FCPR', label: 'FCPR' },
    { id: 'FPS', label: 'FPS' },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private assetDao: AssetDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    combineLatest([
      this.userDao.getCouple(),
      this.assetDao.getReferences(),
      this.assetDao.getProviderByType('PME'),
    ]).subscribe(([users, references, managers]) => {
      this.users = users;
      this.references = references;
      this.sources = references[0];
      this.managers = managers;
    });
  }

  get title() {
    return this.generateTitle(
      "Modifier l'investissement",
      'Ajout d’un investissement private equity',
    );
  }

  generateTitle(editTitle: string, addTitle: string) {
    if (!this.entity || !this.entity.id) return addTitle;
    if (!this.entity.label || this.entity.label === '') return editTitle;
    return `${editTitle} “${this.entity.label}”`;
  }

  ///REFACTO
  selectType(type) {
    // FPCI / FPCR / FCPR / FPS appartiennent à la famille "others"
    // (DTO + endpoint dédiés) : on bascule vers le formulaire adapté.
    if (type !== 'PME') {
      this.prFormService.trigger(EaAutresFormComponent, {
        type,
        accountId: this.entity?.accountId,
        userId: this.entity?.userId,
      });
      return;
    }
    this.form.controls.type.setValue(type);
    this.form.updateValueAndValidity();
    this.assetDao.getProviderByType(type).subscribe(res => {
      this.managers = res;
    });
  }

  onSubmit() {
    this.displayErrors();

    this.selectErrorInput();

    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      if (control && control.invalid) {
        console.log(`${key} is invalid:`, control.errors);
      }
    });

    // Ou pour les FormArray comme 'allocation'
    const allocation = this.form.get('allocation') as UntypedFormArray;
    if (allocation && allocation.invalid) {
      allocation.controls.forEach((control, index) => {
        if (control.invalid) {
          console.log(`allocation[${index}] is invalid:`, control.errors);
        }
      });
    }

    if (this.form.invalid) {
      this.changeTab.next('FIRST');
      return;
    }

    //Fetch every form controls value
    let formDTOExtraction = this.extract();
    this.prFormService.loading();
    this.assetDao
      .proposeManagerProvider(formDTOExtraction, this.managers)
      .pipe(switchMap(() => this.assetDao.saveAssets(formDTOExtraction)))
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          this.notificationService.success('La sauvegarde a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La sauvegarde a échoué');
        },
      );
  }

  onCancel() {
    this.prFormService.close();
  }

  onTabChange(isLastTab: boolean) {
    this.tabChanged.next(isLastTab);
  }

  nextTab() {
    this.changeTab.next('NEXT');
  }
}
